import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(minMax);

const GAP_CONSTANT = 87
const GAP_TOLERANCE = 200

// ==================== DATASET ====================
const datasets = [
  // 1. Multiple Jobs + Old Gaps (with retained reason)
  {
    name: 'Multiple Jobs and Old Gaps',
    workHistories: [
      { id: 'jobA', start: 'Jan-2018', end: 'Sep-2019', type: 'work' },
      { id: 'gap1', start: 'Jul-2018', end: 'Dec-2018', reason: 'Family', type: 'gap' },
      { id: 'jobB', start: 'Jan-2019', end: 'Jun-2019', type: 'work' },
      { id: 'jobC', start: 'Jan-2020', end: 'Jun-2020', type: 'work' }
    ],
    education: [],
    certifications: []
  }

  // 2. Overlapping Jobs with Education fully covering gap
  // {
  //   name: 'Overlapping Jobs with Education in Gap',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2019', end: 'Dec-2019', type: 'work' },
  //     { id: 'job2', start: 'Jun-2019', end: 'May-2020', type: 'work' },
  //     { id: 'gapOld', start: 'Jun-2020', end: 'Aug-2020', reason: 'Travel', type: 'gap' },
  //     { id: 'job3', start: 'Sep-2020', end: 'Jun-2021', type: 'work' }
  //   ],
  //   education: [
  //     { start: 'Jun-2020', end: 'Aug-2020', name: 'Short Course', type: 'education' }
  //   ],
  //   certifications: []
  // },

  // // 3. Gap fully covered by Certification
  // {
  //   name: 'Gap Fully Covered by Certification',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2017', end: 'Mar-2018', type: 'work' },
  //     { id: 'job2', start: 'Jan-2019', end: 'Jun-2019', type: 'work' }
  //   ],
  //   education: [],
  //   certifications: [
  //     { start: 'Apr-2018', end: 'Dec-2018', name: 'AWS Certification', type: 'certification' }
  //   ]
  // },

  // // 4. Multiple small gaps (<88 days) - should not count as gaps
  // {
  //   name: 'Multiple Small Gaps',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2020', end: 'Feb-2020', type: 'work' },
  //     { id: 'job2', start: 'Apr-2020', end: 'May-2020', type: 'work' },
  //     { id: 'job3', start: 'Jul-2020', end: 'Aug-2020', type: 'work' }
  //   ],
  //   education: [],
  //   certifications: []
  // },

  // // 5. Education overlaps partially with gap
  // {
  //   name: 'Partial Education Overlap',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2018', end: 'Jan-2019', type: 'work' },
  //     { id: 'job2', start: 'Jul-2019', end: 'Dec-2019', type: 'work' }
  //   ],
  //   education: [
  //     { start: 'Mar-2019', end: 'Apr-2019', name: 'Workshop', type: 'education' }
  //   ],
  //   certifications: []
  // },

  // // 6. Overlapping Education and Certifications
  // {
  //   name: 'Overlapping Education and Certifications',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2016', end: 'Dec-2016', type: 'work' },
  //     { id: 'job2', start: 'Jan-2018', end: 'Dec-2018', type: 'work' }
  //   ],
  //   education: [
  //     { start: 'Jan-2017', end: 'Jun-2017', name: 'Diploma', type: 'education' },
  //     { start: 'May-2017', end: 'Dec-2017', name: 'Summer Program', type: 'education' }
  //   ],
  //   certifications: [
  //     { start: 'Feb-2017', end: 'Apr-2017', name: 'Scrum Master', type: 'certification' },
  //     { start: 'Mar-2017', end: 'Aug-2017', name: 'PMP', type: 'certification' }
  //   ]
  // },

  // // 7. Gap at start of dataset
  // {
  //   name: 'Gap at Start',
  //   workHistories: [
  //     { id: 'job1', start: 'Jun-2019', end: 'Dec-2019', type: 'work' }
  //   ],
  //   education: [],
  //   certifications: []
  // },

  // // 8. Gap at end of dataset
  // {
  //   name: 'Gap at End',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2018', end: 'Dec-2018', type: 'work' }
  //   ],
  //   education: [],
  //   certifications: []
  // },

  // // 9. Continuous work history - No gaps
  // {
  //   name: 'Continuous Work History',
  //   workHistories: [
  //     { id: 'job1', start: 'Jan-2018', end: 'Jun-2019', type: 'work' },
  //     { id: 'job2', start: 'Jul-2019', end: 'Dec-2020', type: 'work' }
  //   ],
  //   education: [],
  //   certifications: []
  // }
];


// ==================== HELPERS ====================
function parseMonthYear(str) {
  return dayjs(str, ['MMM-YYYY', 'MMM YYYY'], true);
}

function formatMonthYear(date) {
  return date.format('MMM YYYY');
}

function addMonths(date, months) {
  return date.add(months, 'month');
}

function diffDays(d1, d2) {
  return Math.abs(d1.diff(d2, 'day'));
}

// ==================== MAIN PROCESSOR ====================
export function calcWorkGap(pureWorkHistories, educations, certifications, oldGaps) {
  // Step 1: Pure Work Histories
  console.log("Step 1 - Pure Work Histories");
  console.log("Step 2 - Existing Gaps");


  oldGaps = oldGaps.map(wh => { 
    return { ...wh, start: dayjs(wh?.work_history_from).startOf("month").format("MMM-YYYY"), end: dayjs(wh?.work_history_to).endOf("month").format("MMM-YYYY") } 
  })

  pureWorkHistories = pureWorkHistories.map(wh => { 
    return { ...wh, start: dayjs(wh?.work_history_from).startOf("month").format("MMM-YYYY"), end: dayjs(wh?.work_history_to || Date.now()).endOf("month").format("MMM-YYYY") } 
  })

  educations = educations.map(wh => { 
    return { ...wh, start: dayjs(wh?.education_from).startOf("month").format("MMM-YYYY"), end: dayjs(wh?.education_to).endOf("month").format("MMM-YYYY") } 
  })

  certifications = certifications.map(wh => { 
    return { ...wh, start: dayjs(wh?.education_from).startOf("month").format("MMM-YYYY"), end: dayjs(wh?.education_to).endOf("month").format("MMM-YYYY") } 
  })

  const { earliestJobStart, filteredEducation, filteredCertifications } = filterEduAndCertAfterEarliestJob(pureWorkHistories, educations, certifications)

  const timeline = [...pureWorkHistories, ...filteredEducation, ...filteredCertifications].sort((a, b) => parseMonthYear(a.start) - parseMonthYear(b.start));
  // Step 3: Merge overlapping works
  console.log("Step 3 - Merged Work Histories Overlaps");
  const mergedTimeline = mergeOverlaps(timeline);

  // Step 4: Identify new gaps
  console.log("Step 4 - Identify New Gaps");
  const newGaps = identifyNewGaps(mergedTimeline, [], []);

  // Step 5: Retain old gap reasons (fuzzy match ±88 days)
  console.log("Step 5 - Retained Gaps with Reasons");
  const retainedGaps = retainGapReasons(newGaps, oldGaps, GAP_TOLERANCE);

  // Step 6: Merge updated gaps into final
  const updatedHistories = [...pureWorkHistories, ...retainedGaps]
    .sort((a, b) => parseMonthYear(b.start) - parseMonthYear(a.start));

  // const updatedHistories = specialSort([...pureWorkHistories, ...retainedGaps])
  console.log("Step 6 - Final Sorted Histories");
  return { updatedHistories, retainedGaps }
}

function filterEduAndCertAfterEarliestJob(workHistories, education, certifications) {
  if (!workHistories.length) {
    return { filteredEducation: [], filteredCertifications: [] };
  }

  // Find earliest job start
  const earliestJobStart = workHistories
    .map(job => parseMonthYear(job.start))
    .reduce((min, date) => date.isBefore(min) ? date : min);

  // Helper: check overlap with job
  function overlapsWithJob(start, end) {
    const jobStart = earliestJobStart;
    return (
      start.isSameOrAfter(jobStart) || // edu/cert starts after job start
      (end && jobStart.isBetween(start, end, null, '[]')) // job falls within edu/cert period
    );
  }

  // Filter
  const filteredEducation = education.filter(e => {
    const eduStart = parseMonthYear(e.start);
    const eduEnd = e.end ? parseMonthYear(e.end) : null;
    return overlapsWithJob(eduStart, eduEnd);
  });

  const filteredCertifications = certifications.filter(c =>{
    const certStart = parseMonthYear(c.start);
    const certEnd = c.end ? parseMonthYear(c.end) : null;
    return overlapsWithJob(certStart, certEnd);
  });

  return { earliestJobStart, filteredEducation, filteredCertifications };
}

// ==================== LOGIC FUNCTIONS ====================
function mergeOverlaps(jobs) {
  if (!jobs.length) return [];
  const sorted = [...jobs].sort((a, b) => parseMonthYear(a.start) - parseMonthYear(b.start));
  const merged = [sorted[0]];

  for (let i = 1; i < sorted.length; i++) {
    const prev = merged[merged.length - 1];
    if (parseMonthYear(sorted[i].start).isSameOrBefore(parseMonthYear(prev.end))) {
      prev.end = formatMonthYear(
        dayjs.max(parseMonthYear(prev.end), parseMonthYear(sorted[i].end))
      );
    } else {
      merged.push(sorted[i]);
    }
  }
  return merged;
}

function identifyNewGaps(jobs, education, certifications) {
  const gaps = [];
  for (let i = 0; i < jobs.length - 1; i++) {
    const gapStart = addMonths(parseMonthYear(jobs[i].end), 1).startOf('month');
    const gapEnd = addMonths(parseMonthYear(jobs[i + 1].start), -1).endOf('month');

    // Calculate gap duration in days
    const gapDuration = gapEnd.diff(gapStart, 'day') + 1; // +1 to include both start and end dates

    if (gapEnd.isSameOrAfter(gapStart) &&
        gapDuration >= GAP_CONSTANT && !hasEducationOrCert(gapStart, gapEnd, education, certifications)) {
      gaps.push({
        work_history_from: gapStart.format(),
        work_history_to: gapEnd.format(),
        start: formatMonthYear(gapStart),
        end: formatMonthYear(gapEnd),
        highest_designation: `${gaps?.length + 1}`,
      });
    }
  }

  // Gap after last job
  const lastJob = jobs[jobs.length - 1];
  const lastJobEnd = parseMonthYear(lastJob.end);
  const now = dayjs().startOf('month');
  const endOfCurrentMonth = dayjs().endOf('month');
  const today = dayjs()

  if (lastJobEnd.isBefore(now)) {
    const gapStart = lastJobEnd.add(1, 'month').startOf('month');
    let gapEnd = endOfCurrentMonth;


    if (today.isBefore(endOfCurrentMonth)) {
      gapEnd = today; // current month in progress → end today

      // Calculate gap duration in days
      const gapDuration = gapEnd.diff(gapStart, 'day') + 1; // +1 to include both start and end dates

      if (gapEnd.isSameOrAfter(gapStart) && gapDuration >= GAP_CONSTANT) {
        gapEnd = gapEnd.add(-1, 'month').endOf('month');
        gaps.push({
          work_history_from: gapStart.format(),
          work_history_to: gapEnd.format(),
          start: formatMonthYear(gapStart),
          end: formatMonthYear(gapEnd),
          highest_designation: `${gaps?.length + 1}`,
        });
      }
    } else {
      // Calculate gap duration in days
      const gapDuration = gapEnd.diff(gapStart, 'day') + 1; // +1 to include both start and end dates
      if (gapEnd.isSameOrAfter(gapStart) && gapDuration >= GAP_CONSTANT) {
        gaps.push({
          work_history_from: gapStart.format(),
          work_history_to: gapEnd.format(),
          start: formatMonthYear(gapStart),
          end: formatMonthYear(gapEnd),
          highest_designation: `${gaps?.length + 1}`,
        });
      }
    }
  }
  return gaps;
}

function hasEducationOrCert(start, end, education, certifications) {
  const inRange = (item) =>
    parseMonthYear(item.start).isSameOrBefore(end) &&
    parseMonthYear(item.end).isSameOrAfter(start);
  return education.some(inRange) || certifications.some(inRange);
}

function retainGapReasons(newGaps, oldGaps, toleranceDays) {
  return newGaps.map(gap => {
    const match = oldGaps.find(oldGap => {
      const startDiff = diffDays(parseMonthYear(gap.start), parseMonthYear(oldGap.start));
      const endDiff = diffDays(parseMonthYear(gap.end), parseMonthYear(oldGap.end));
      const durationDiff = Math.abs(
        diffDays(parseMonthYear(gap.end), parseMonthYear(gap.start)) -
        diffDays(parseMonthYear(oldGap.end), parseMonthYear(oldGap.start))
      );

      return (startDiff <= toleranceDays || endDiff <= toleranceDays) // && durationDiff <= toleranceDays * 2;

    });
    gap = { 
        ...gap,  
        organization_name: 'Work Gap',
        gap_explaination: "",
        show_in_resume: false
    }
    return match ? { 
        ...gap, 
        organization_name: 'Work Gap',
        gap_explaination: match?.gap_explaination,
        gap_title: match?.gap_title,
        show_in_resume: match?.show_in_resume,
    } : gap;
  });
}